import { render, staticRenderFns } from "./CommodityCard.vue?vue&type=template&id=31dc14ac&scoped=true&"
import script from "./CommodityCard.vue?vue&type=script&lang=js&"
export * from "./CommodityCard.vue?vue&type=script&lang=js&"
import style0 from "./CommodityCard.vue?vue&type=style&index=0&id=31dc14ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc14ac",
  null
  
)

export default component.exports